module.exports = __webpack_public_path__ + "img/guidelist-echart.031470cb.png";